import { createLazyFileRoute, Outlet } from "@tanstack/react-router";
import { memo } from "react";
import { useTitle } from "react-use";

import { MainApp } from "@/components/AppMain";
import { CommandMenu, CommandMenuProvider } from "@/components/CommandMenu";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/features/admin/components/AdminSidebar";

export const Route = createLazyFileRoute("/_auth/admin")({
  component: memo(() => {
    useTitle("Admin");
    return (
      <SidebarProvider>
        <MainApp sidebar={<AdminSidebar />}>
          <div className="flex flex-col flex-1 p-6 overflow-auto">
            <Outlet />
          </div>
          <CommandMenuProvider>
            <CommandMenu />
          </CommandMenuProvider>
        </MainApp>
      </SidebarProvider>
    );
  }),
});
